import SubsectionTitle from "../../components/section-items/SubsectionTitle/SubsectionTitle";
import SubsectionBlock from "../../components/section-items/SubsectionBlock/SubsectionBlock";
import React, {useEffect, useState} from "react";
import {fetchData} from "../../helpers/fetchData";
import DataTable from "../../components/tables/DataTable/DataTable";
import LoadingSpinner from "../../components/spinners/LoadingSpinner";
import ManageDataForm from "../../components/forms/ManageDataForm";
import PropTypes from "prop-types";

const ManageData = ({type}) => {

    const [data, setData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);

    const title = {
        posts: 'Posty',
        players: 'Zawodnicy',
        matches: 'Mecze',
        tournaments: 'Turnieje'
    };

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    const sendDataToParent = (updatedData) => {
        if(updatedData) {
            getData();
        }
    }

    const getData = () => {
        setData([]);
        setIsFetching(true);
        fetchData(type === 'posts' ? 'posts/all' : type)
            .then((res) => setData(res))
            .then(() => setIsFetching(false))
            .catch((e) => console.error(e));
    }

    return (
        <SubsectionBlock id={'admin_' + type}>
            <SubsectionTitle color={'black'}>{title[type]}</SubsectionTitle>
            {
                isFetching ? <LoadingSpinner/> :
                    <>
                        <DataTable data={data} dataType={type} adminTable sendDataToParent={sendDataToParent}/>
                        <ManageDataForm formType={type} sendDataToParent={sendDataToParent}/>
                    </>
            }
        </SubsectionBlock>
    );
};

ManageData.propTypes = {
    type: PropTypes.string.isRequired
}

export default ManageData;
